const fallback = (value, defaultValue = '0') => {
  if (value === undefined || value === null || value === '') {
    return defaultValue;
  }
  return value;
};

export const generateShareSummary = (snapshot = {}) => {
  const date = fallback(snapshot.date, new Date().toLocaleDateString());
  const pitcher = fallback(snapshot.pitcherName, 'N/A');
  const opponent = fallback(snapshot.opponent, 'N/A');
  const pitches = fallback(snapshot.pitches, 0);
  const strikes = fallback(snapshot.strikes, 0);
  const balls = fallback(snapshot.balls, 0);
  const outs = fallback(snapshot.outs, 0);
  const innings = fallback(snapshot.innings, 0);
  const runsAllowed = fallback(snapshot.runsAllowed, 0);
  const stats = snapshot.stats || {};

  const kbb = fallback(stats.kbb, '0.00');
  const whip = fallback(stats.whip, '0.00');
  const pip = fallback(stats.pip, '0.0');
  const strikeRate = fallback(snapshot.strikeRate, 0);
  const outRate = fallback(snapshot.outRate, 0);
  const runsPerInning = fallback(snapshot.runsPerInning, 0);

  return `【Pitch Counter】${date}\nPitcher: ${pitcher} vs Opp: ${opponent}\n` +
    `Pitches: ${pitches}球 (S${strikes}/B${balls}) | Outs: ${outs} / Inn: ${innings} / Runs: ${runsAllowed}\n` +
    `Stats -> K/BB:${kbb} WHIP:${whip} P/IP:${pip}\n` +
    `Strike%:${strikeRate}% P/Out:${outRate} R/Inn:${runsPerInning}`;
};
